<template>
  <div class="home">
    <div class="top">
      <span>本体教育</span>
      <span>国内领先的智慧校园平台服务商</span>
    </div>
    <h3>本体教育平台</h3>
    <div class="short_stub">
      <div></div>
      <div></div>
    </div>
    <div class="plan">
      <div
        class="plan_item"
        style="background: url('//static.h5.ylmob.com/website/img/img_access.png') no-repeat; background-size: 100% 100%;"
        @mouseover="showHover(1)"
      >
        <transition name="fade" mode="out-in">
          <div v-if="hoverIndex==1" class="item_hover" key="anquan1">
            <span>出入安全管理</span>
            <div class="hover_line"></div>
            <span>校门进出口或通行区域部署人脸考勤设备，学生出入数据实时统计推送家长，实时掌握学生到校/离校情况。</span>
          </div>
          <div v-else class="plan_item_d" key="anquan2">出入安全管理</div>
        </transition>
      </div>
      <div
        class="plan_item"
        style="background: url('//static.h5.ylmob.com/website/img/img_interactive1.png') no-repeat; background-size: 100% 100%;"
        @mouseover="showHover(2)"
      >
        <div v-if="hoverIndex==2" class="item_hover">
          <span>家校互动</span>
          <div class="hover_line"></div>
          <span>支持家长和教师互动、接收学生实时进出刷脸记录、可视化查询学生考勤、成绩、请假条申请等记录，全方位了解学生在校情况。</span>
        </div>
        <div v-else class="plan_item_d">家校互动</div>
      </div>
      <div
        class="plan_item"
        style="background: url('//static.h5.ylmob.com/website/img/img_interactive2.png') no-repeat; background-size: 100% 100%;"
        @mouseover="showHover(3)"
      >
        <div v-if="hoverIndex==3" class="item_hover">
          <span>校园电话</span>
          <div class="hover_line"></div>
          <span>学生通过刷脸识别后拨打家长手机号码，提供可视化视频电话和网络电话多种组合方式 ，方便学生联系家长。</span>
        </div>
        <div v-else class="plan_item_d">校园电话</div>
      </div>
    </div>
    <div class="plan">
      <div
        class="plan_item"
        style="background: url('//static.h5.ylmob.com/website/img/img_visitors.png') no-repeat; background-size: 100% 100%;"
        @mouseover="showHover(4)"
      >
        <div v-if="hoverIndex==4" class="item_hover">
          <span>校园访客管理</span>
          <div class="hover_line"></div>
          <span>校门口或教学楼部署访客实名登记设备，比对人证、设置滞留时间、访问权限等，简化登记流程，提高安全性。</span>
        </div>
        <div v-else class="plan_item_d">校园访客管理</div>
      </div>
      <div
        class="plan_item"
        style="background: url('//static.h5.ylmob.com/website/img/img_measurement.png') no-repeat; background-size: 100% 100%;"
        @mouseover="showHover(5)"
      >
        <div v-if="hoverIndex==5" class="item_hover">
          <span>测温防疫</span>
          <div class="hover_line"></div>
          <span>利用人脸识别和红外测温技术，校园出入人员可自助式完成测温工作，减少传统人工测温带来的交叉感染风险，实现人员快速通行。</span>
        </div>
        <div v-else class="plan_item_d">测温防疫</div>
      </div>
      <div
        class="plan_item"
        style="background: url('//static.h5.ylmob.com/website/img/img_safe.png') no-repeat; background-size: 100% 100%;"
        @mouseover="showHover(6)"
      >
        <div v-if="hoverIndex==6" class="item_hover">
          <span>安全预警布控</span>
          <div class="hover_line"></div>
          <span>对校内重点区域实行人脸安全布控，出现黑名单人员，系统实时预警提示，保证在校师生的人身财产安全。</span>
        </div>
        <div v-else class="plan_item_d">安全预警布控</div>
      </div>
    </div>
    <h3>我们的愿景</h3>
    <div class="short_stub">
      <div></div>
      <div></div>
    </div>
    <div class="mission">
      <img src="//static.h5.ylmob.com/website/img/img_ball.png" />
      <div class="mission_r">
        <div class="mission_r_i">
          <span>为学生</span>
          <span>营造安全、便捷、舒适的学习环境</span>
          <div class="mission_tag"></div>
        </div>
        <div class="mission_r_i">
          <span>为校方管理者</span>
          <span>提供高效、可靠、安全的管理手段</span>
          <div class="mission_tag"></div>
        </div>
        <div class="mission_r_i">
          <span>为教师</span>
          <span>打造高效智能的学生管理工具，让其有更多的精力投入到教学工作中</span>
          <div class="mission_tag"></div>
        </div>
        <div class="mission_r_i">
          <span>为家长</span>
          <span>提供方便、精准、高效的数字化服务，了解学生在校期间的学习和生活状态</span>
          <div class="mission_tag"></div>
        </div>
      </div>
    </div>
    <h3>已获成就</h3>
    <div class="short_stub">
      <div></div>
      <div></div>
    </div>
    <div class="achievement">
      <div class="achievement_i">
        <span>100+</span>
        <span>服务线下学校数量</span>
      </div>
      <div class="achievement_i">
        <span>100000+</span>
        <span>服务师生家长数量</span>
      </div>
      <div class="achievement_i">
        <span>30+</span>
        <span>覆盖全国省市地区</span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {},
  data() {
    return {
      hoverIndex: 0
    };
  },
  methods: {
    showHover(index) {
      this.hoverIndex = index;
    }
  }
};
</script>

<style scoped>
/* .fade-enter-active, .fade-leave-active {
  transition: all 1s ease;
}
.fade-enter, .fade-leave-to  {
  transform:translateY(-200px);
  opacity: 0;
} */

.home {
  width: 100%;
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */
  display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */
  /* 09版 */
  -webkit-box-orient: vertical;
  /* 12版 */
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  /* 09版 */
  -webkit-box-align: center;
  /* 12版 */
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
.top {
  width: 100%;
  height: 2.604167rem;
  background: url("//static.h5.ylmob.com/website/img/banner.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.top span:nth-child(1) {
  font-size: 0.3125rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 0.3125rem;
  margin-left: 2.395833rem;
}
.top span:nth-child(2) {
  font-size: 0.15625rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
  line-height: 0.15625rem;
  margin-top: 0.15625rem;
  margin-left: 2.395833rem;
}
.banner {
  width: 100%;
  /* height: 2.604167rem; */
}

.plan {
  display: flex;
  align-items: center;
  margin-bottom: 0.208333rem;
}
.plan_item {
  width: 1.942708rem;
  height: 1.302083rem;
  margin: 0 0.104167rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.plan_item_d {
  width: 100%;
  height: 0.333333rem;
  background: rgba(47, 110, 240, 0.6);
  font-size: 0.125rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.333333rem;
  text-align: center;
}
.mission {
  display: flex;
}
.mission > img {
  width: 1.5625rem;
  height: 1.489583rem;
  margin-left: 0.3125rem;
  margin-top: 0.239583rem;
}
.mission_r {
  display: flex;
  flex-direction: column;
  margin-left: 0.833333rem;
  margin-top: 0.208333rem;
}
.mission_r_i {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.25rem;
  align-items: flex-start;
}
.mission_tag {
  position: absolute;
  width: 0.104167rem;
  height: 0.104167rem;
  background: rgba(47, 110, 240, 1);
  opacity: 0.15;
  border-radius: 50%;
  top: -0.052083rem;
  left: -0.052083rem;
}
.mission_r_i span:nth-child(1) {
  font-size: 0.083333rem;
  font-weight: 600;
  color: rgba(63, 110, 240, 1);
  line-height: 0.083333rem;
}
.mission_r_i span:nth-child(2) {
  font-size: 0.083333rem;
  font-weight: 400;
  color: rgba(9, 22, 48, 1);
  line-height: 0.083333rem;
  margin-top: 0.052083rem;
}
.achievement {
  display: flex;
  margin-top: 0.208333rem;
  margin-bottom: 0.416667rem;
}
.achievement_i {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0.572917rem;
}
.achievement_i span:nth-child(1) {
  font-size: 0.3125rem;
  font-weight: 500;
  color: rgba(63, 110, 240, 1);
  line-height: 0.3125rem;
}
.achievement_i span:nth-child(2) {
  font-size: 0.09375rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 0.09375rem;
  margin-top: 0.125rem;
}
.item_hover {
  width: 100%;
  height: 100%;
  padding: 0.208333rem 0.208333rem 0 0.208333rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: rgba(47, 110, 240, 0.8);
  box-sizing: border-box;
}
.item_hover span:nth-child(1) {
  font-size: 0.125rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.125rem;
  margin-bottom: 0.104167rem;
  text-align: left;
}
.hover_line {
  width: 0.078125rem;
  height: 0.010417rem;
  background: rgba(255, 255, 255, 1);
  margin-bottom: 0.15625rem;
}
.item_hover span:last-child {
  font-size: 0.083333rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.125rem;
  text-align: left;
}
</style>
